import React from 'react'
import { Input, Label } from 'reactstrap'

const DropdownHeader = ({ checked, setChecked, label }) => {
  return (
    <Label
      className="d-block course-filter"
      htmlFor="active-courses"
    >
      <Input
        className="checkbox_animated"
        id="active-courses"
        type="checkbox"
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      />
      {label}
    </Label>
  )
}

export default DropdownHeader